import { useMantineTheme } from '@mantine/core';
import dayjs from 'dayjs';
import { useProfile } from 'init/use-enforce-profile';
import { useLoadGroupAnalytics } from 'shared/hooks/use-load-group-analytics';

const lastCompletedMonthEnd = () =>
  dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');

export const useConsolidation = (selectedCompanies: ReadonlyArray<string>) =>
  useLoadGroupAnalytics({ date: lastCompletedMonthEnd(), companies: selectedCompanies });

export const useGroupTenants = () => {
  const { accessibleTenants, group } = useProfile();

  return accessibleTenants.filter(tenant => tenant.groupId === group?.id);
};

export const useCompanyNameOf = () => {
  const { accessibleTenants } = useProfile();

  return (subdomain: string) =>
    accessibleTenants.find(tenant => tenant.subdomain === subdomain)?.companyName ?? subdomain;
};

export const useCompanyColorOf = () => {
  const theme = useMantineTheme();
  const groupTenants = useGroupTenants();
  const palette = [
    theme.colors.purple[5],
    theme.colors.coral[6],
    theme.colors.validation[6],
    theme.colors.warning[5],
    theme.colors.purple[7],
    theme.colors.coral[8],
    theme.colors.gray[7],
    theme.colors.purple[3],
  ];

  return (subdomain: string) =>
    palette[groupTenants.findIndex(tenant => tenant.subdomain === subdomain)] ??
    theme.colors.gray[5];
};
